import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import ASSET_SIDEBAR_DATA from 'data/assetSidebarData';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import NavBar from 'components/NavBar';
import styles from './AssetSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';

export default function AssetSidebar() {
  return (
    <>
      <NavBar
        title="ASSET MANAGEMENT TOOL"
        className="p-xs"
        id="asset-sidebar"
      />
      <ElementSpacePlaceholder elementId="asset-sidebar" />
      <div className={styles.root}>
        {ASSET_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={sectionIndex}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={tabIndex}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
